<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <clipPath id="gs-clip-vue">
        <rect x="50" y="20" width="100" height="110" class="gs-reveal" />
      </clipPath>
    </defs>

    <!-- Chart card background -->
    <rect
      x="34"
      y="28"
      width="132"
      height="94"
      rx="8"
      fill="#f5f3ff"
      stroke="#e9d5ff"
      stroke-width="1"
    />

    <!-- Subtle gridlines -->
    <line x1="46" y1="50" x2="154" y2="50" stroke="#ede9fe" stroke-width="1" />
    <line x1="46" y1="72" x2="154" y2="72" stroke="#ede9fe" stroke-width="1" />
    <line x1="46" y1="94" x2="154" y2="94" stroke="#ede9fe" stroke-width="1" />

    <!-- Chart axes -->
    <line
      x1="46"
      y1="42"
      x2="46"
      y2="104"
      stroke="#c4b5fd"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <line
      x1="46"
      y1="104"
      x2="154"
      y2="104"
      stroke="#c4b5fd"
      stroke-width="1.5"
      stroke-linecap="round"
    />

    <!-- Goal line (horizontal target) -->
    <line
      x1="46"
      y1="46"
      x2="154"
      y2="46"
      stroke="#7c3aed"
      stroke-width="1.5"
      stroke-dasharray="4 4"
      class="gs-goal-line"
    />

    <!-- Rising trend line (dashed) -->
    <polyline
      points="50,100 75,86 100,68 125,58 150,46"
      fill="none"
      stroke="#8b5cf6"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-dasharray="4 4"
      clip-path="url(#gs-clip-vue)"
    />

    <!-- Endpoint markers -->
    <circle cx="150" cy="46" r="2.5" fill="#7c3aed" class="gs-endpoint" />
    <circle cx="50" cy="100" r="3" fill="#a78bfa" />
  </svg>
</template>

<style scoped>
@keyframes gs-reveal {
  0% {
    transform: scaleX(0);
  }
  60%,
  100% {
    transform: scaleX(1);
  }
}
@keyframes gs-dot {
  0%,
  55% {
    opacity: 0;
  }
  65%,
  100% {
    opacity: 1;
  }
}
@keyframes gs-goal {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.3;
  }
}
.gs-reveal {
  transform-origin: 50px 0;
  animation: gs-reveal 3.5s ease-in-out infinite;
}
.gs-endpoint {
  animation: gs-dot 3.5s ease-in-out infinite;
}
.gs-goal-line {
  animation: gs-goal 3s ease-in-out infinite;
}
</style>
